/**
 * Minimal RFC-4180-compatible CSV parser.
 *
 * Returns an array of string-array rows (header included if present).
 * Handles: quoted fields, embedded commas, embedded newlines in quotes,
 * escaped double-quotes ("").
 */
export function parseCsv(text: string): string[][] {
  const rows: string[][] = [];
  let row: string[] = [];
  let field = '';
  let inQuotes = false;
  const n = text.length;

  for (let i = 0; i < n; i++) {
    const ch = text[i];
    if (inQuotes) {
      if (ch === '"') {
        if (text[i + 1] === '"') {
          field += '"';
          i++;
        } else inQuotes = false;
      } else {
        field += ch;
      }
    } else {
      if (ch === '"') {
        inQuotes = true;
      } else if (ch === ',') {
        row.push(field);
        field = '';
      } else if (ch === '\n') {
        row.push(field);
        field = '';
        if (row.some((v) => v !== '')) rows.push(row);
        row = [];
      } else if (ch === '\r') {
        // skip CR (handle \r\n)
      } else {
        field += ch;
      }
    }
  }
  // last field / row
  row.push(field);
  if (row.some((v) => v !== '')) rows.push(row);

  return rows;
}

/** Read a File as text via FileReader (Promise wrapper). */
export function readFileAsText(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result as string);
    r.onerror = () => reject(r.error);
    r.readAsText(file, 'utf-8');
  });
}
